import { doc, onSnapshot } from "firebase/firestore";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { ChatContext } from "../context/ChatContext";
import { db } from "../firebase";
import { generateGroupIcon } from "../utils/groupIcon";
import GroupAvatar from "./GroupAvatar";

const Chats = () => {
  const [chats, setChats] = useState([]);

  const { currentUser, userEventCode } = useContext(AuthContext);
  const { dispatch } = useContext(ChatContext);

  console.log("Chats component - currentUser:", currentUser?.uid, "userEventCode:", userEventCode);

  useEffect(() => {
    const getChats = () => {
      if (!currentUser.uid || !userEventCode) {
        console.log("Missing currentUser.uid or userEventCode:", currentUser.uid, userEventCode);
        return;
      }
      
      console.log("Loading chats for user:", currentUser.uid, "event:", userEventCode);
      
      // Try new format first (event-specific chats)
      const eventSpecificChatsId = `${currentUser.uid}_${userEventCode}`;
      console.log("Trying event-specific chats ID:", eventSpecificChatsId);
      
      const unsub = onSnapshot(doc(db, "userChats", eventSpecificChatsId), (doc) => {
        console.log("Event-specific document exists:", doc.exists());
        if (doc.exists()) {
          const allChats = doc.data() || {};
          console.log("Event-specific chats loaded:", Object.keys(allChats).length, "chats");
          // All chats in event-specific document are already filtered
          setChats(allChats);
        } else {
          console.log("Event-specific document doesn't exist, trying fallback to:", currentUser.uid);
          // Fallback to old format and filter by eventCode
          const fallbackUnsub = onSnapshot(doc(db, "userChats", currentUser.uid), (doc) => {
            console.log("Fallback document exists:", doc.exists());
            const allChats = doc.data() || {};
            console.log("All chats in fallback document:", Object.keys(allChats).length);
            
            // Filter chats by eventCode or events array
            const filteredChats = {};
            Object.entries(allChats).forEach(([chatId, chatData]) => {
              console.log("Checking chat:", chatId, "eventCode:", chatData.eventCode, "events:", chatData.events, "looking for:", userEventCode);
              
              // Check if chat belongs to current event
              let belongsToEvent = false;
              
              // Check old format (eventCode)
              if (chatData.eventCode === userEventCode) {
                belongsToEvent = true;
              }
              
              // Check new format (events array)
              if (chatData.events && Array.isArray(chatData.events) && chatData.events.includes(userEventCode)) {
                belongsToEvent = true;
              }
              
              if (belongsToEvent) {
                filteredChats[chatId] = chatData;
                console.log("Added chat to filtered list:", chatId);
              }
            });
            console.log("Filtered chats for", userEventCode, ":", Object.keys(filteredChats).length);
            setChats(filteredChats);
          });
          
          return () => fallbackUnsub();
        }
      });

      return () => {
        unsub();
      };
    };

    const unsubscribe = getChats();
    return unsubscribe;
  }, [currentUser.uid, userEventCode]);

  const handleSelect = (chatData, chatId) => {
    if (chatData.isGroup) {
      dispatch({ 
        type: "CHANGE_GROUP", 
        payload: { 
          groupId: chatId, 
          ...chatData.groupInfo 
        } 
      });
    } else {
      // Ensure userInfo has required fields
      const userInfo = {
        uid: chatData.userInfo?.uid || "unknown",
        displayName: chatData.userInfo?.displayName || "Unknown User",
        photoURL: chatData.userInfo?.photoURL || "https://via.placeholder.com/50/6c757d/ffffff?text=U",
        ...chatData.userInfo
      };
      
      dispatch({ type: "CHANGE_USER", payload: userInfo });
    }
  };

  return (
    <div className="chats">
      {Object.entries(chats).length === 0 && (
        <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
          <p>No chats found for event: {userEventCode}</p>
          <p>Try searching for users to start a conversation</p>
        </div>
      )}
      {Object.entries(chats)
        ?.filter(([chatId, chatData]) => {
          // Filter out chats with invalid data structure
          if (chatData.isGroup) {
            const hasGroupName = chatData.groupInfo?.name;
            console.log("Group chat", chatId, "has name:", hasGroupName);
            return hasGroupName; // Group must have a name
          } else {
            const hasUserInfo = chatData.userInfo;
            console.log("1-on-1 chat", chatId, "has userInfo:", hasUserInfo, "data:", chatData.userInfo);
            return hasUserInfo; // 1-on-1 chat must have userInfo (even if some fields are missing)
          }
        })
        ?.sort((a,b)=>b[1].date - a[1].date)
        ?.map((chat) => {
          console.log("Rendering chat:", chat[0], "data:", chat[1]);
          return (
        <div
          className="userChat"
          key={chat[0]}
          onClick={() => handleSelect(chat[1], chat[0])}
        >
          {chat[1].isGroup ? (
            <GroupAvatar 
              groupName={chat[1].groupInfo?.name} 
              size={50} 
            />
          ) : (
            <img 
              src={chat[1].userInfo?.photoURL || "https://via.placeholder.com/50/6c757d/ffffff?text=U"} 
              alt="" 
            />
          )}
          <div className="userChatInfo">
            <span>
              {chat[1].isGroup 
                ? chat[1].groupInfo?.name 
                : (chat[1].userInfo?.displayName || "Unknown User")
              }
            </span>
            <p>{chat[1].lastMessage?.text}</p>
          </div>
          {chat[1].isGroup && (
            <div className="groupIndicator">
              <small>{chat[1].groupInfo?.members?.length} members</small>
            </div>
          )}
        </div>
          );
        })}
    </div>
  );
};

export default Chats;
